<template>
    <DeprecatedDataTable
        id="machines"
        url="/api/machines/datatable"
        label="Machines"
        :columns="columns"
    />
</template>

<script setup>
import DeprecatedDataTable from "./../../datatable/DeprecatedDataTable.vue";

const columns = [
    { data: "id", render: machineUrl },
    { data: "serial", title: "Serial", render: machineUrl },
    { data: "pin", title: "PIN" },
    { data: "patient.email", title: "Patient" },
    {
        title: "Provider",
        data: "dme",
        render: {
            _: "name",
            // sort: "dme.name",
            filter: "id",
        },
    },
];

function machineUrl(data, type, row, meta) {
    if (type === 'display') {
        return `<a href="/machines/${row.id}">${data}</a>`;
    }
}
</script>
